import { isAndroidMobile } from '@/services/platformService'

const TRACK_FILE_ACCEPT = '.gpx,.fit'
const MIXED_IMPORT_FILE_ACCEPT = '.gpx,.fit,.jpg,.jpeg,.png,.webp,.heic,.heif'

// Android WebView maps unknown track extensions alongside image extensions to an image-only picker
// intent. Omitting `accept` keeps GPX/FIT documents visible; import handlers still validate every
// selected filename before processing it.
export function getTrackFilePickerAccept(android = isAndroidMobile()): string | undefined {
  return android ? undefined : TRACK_FILE_ACCEPT
}

export function getMixedImportFilePickerAccept(android = isAndroidMobile()): string | undefined {
  return android ? undefined : MIXED_IMPORT_FILE_ACCEPT
}
